
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexuziFWTvz0W7nbgQBHcRaUDcNZE_45uIJmwM4y9hEwzF_EMeta } from "C:/Users/brend/GIT/tgi-partner-rentprotect/pages/index.vue?macro=true";
import { default as privacy_0uIhHJCPRi4R4lHE0IAPjRdntqkNVAOV3Lukhl6rE8Meta } from "C:/Users/brend/GIT/tgi-partner-rentprotect/pages/privacy.vue?macro=true";
import { default as successFMsH_45c0PQG5Rkxf1hXoYbtOQ0Pu0iQEARdpQ7zpJjDUMeta } from "C:/Users/brend/GIT/tgi-partner-rentprotect/pages/success.vue?macro=true";
import { default as complaintsFEE2AWJMgErOwhHbkJDzqCQ4QQi0_3cqPcPd_45NdjpxMMeta } from "C:/Users/brend/GIT/tgi-partner-rentprotect/pages/complaints.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    meta: indexuziFWTvz0W7nbgQBHcRaUDcNZE_45uIJmwM4y9hEwzF_EMeta || {},
    component: () => import("C:/Users/brend/GIT/tgi-partner-rentprotect/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexuziFWTvz0W7nbgQBHcRaUDcNZE_45uIJmwM4y9hEwzF_EMeta || {},
    component: () => import("C:/Users/brend/GIT/tgi-partner-rentprotect/pages/index.vue")
  },
  {
    name: "privacy___en",
    path: "/privacy",
    meta: privacy_0uIhHJCPRi4R4lHE0IAPjRdntqkNVAOV3Lukhl6rE8Meta || {},
    component: () => import("C:/Users/brend/GIT/tgi-partner-rentprotect/pages/privacy.vue")
  },
  {
    name: "privacy___fr",
    path: "/fr/privacy",
    meta: privacy_0uIhHJCPRi4R4lHE0IAPjRdntqkNVAOV3Lukhl6rE8Meta || {},
    component: () => import("C:/Users/brend/GIT/tgi-partner-rentprotect/pages/privacy.vue")
  },
  {
    name: "success___en",
    path: "/success",
    meta: successFMsH_45c0PQG5Rkxf1hXoYbtOQ0Pu0iQEARdpQ7zpJjDUMeta || {},
    component: () => import("C:/Users/brend/GIT/tgi-partner-rentprotect/pages/success.vue")
  },
  {
    name: "success___fr",
    path: "/fr/success",
    meta: successFMsH_45c0PQG5Rkxf1hXoYbtOQ0Pu0iQEARdpQ7zpJjDUMeta || {},
    component: () => import("C:/Users/brend/GIT/tgi-partner-rentprotect/pages/success.vue")
  },
  {
    name: "complaints___en",
    path: "/complaints",
    meta: complaintsFEE2AWJMgErOwhHbkJDzqCQ4QQi0_3cqPcPd_45NdjpxMMeta || {},
    component: () => import("C:/Users/brend/GIT/tgi-partner-rentprotect/pages/complaints.vue")
  },
  {
    name: "complaints___fr",
    path: "/fr/complaints",
    meta: complaintsFEE2AWJMgErOwhHbkJDzqCQ4QQi0_3cqPcPd_45NdjpxMMeta || {},
    component: () => import("C:/Users/brend/GIT/tgi-partner-rentprotect/pages/complaints.vue")
  }
]